import {Company, type CompanyData} from "@/types/company/company";

export class OrderEntryEmail {
    public id:number|null;
    public name:string;
    public is_general:boolean;
    public companies: Company[];

    constructor(data:OrderEntryEmailData|void) {
        if(data === undefined)
        {
            this.id = null;
            this.name = "";
            this.is_general = false;
            this.companies = [];
        }
        else
        {
            this.id = data.id;
            this.name = data.name;
            this.is_general = data.is_general;
            this.companies = [];
            if (data.companies !== undefined) {
                data.companies.forEach(company => this.companies.push((new Company(company))));
            }
        }
    }

    serializeData(without_relations: boolean | Array<string> = false) {
        const serialized_data =  {
            id: this.id,
            name: this.name,
            is_general: this.is_general,
        }
        if (without_relations === false ||
            (
                Array.isArray(without_relations) &&
                !without_relations.includes('companies')
            )
        ) {
            serialized_data.companies = [];
            this.companies.forEach(el => {
                serialized_data.companies.push(el.serializeData())
            })
        }

        return serialized_data;
    }
}

export type OrderEntryEmailData = {
    id:number|null;
    name:string;
    is_general:boolean;
    companies: CompanyData[];
}